import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/admin-login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/Login')
  },
  {
    path: '/data-platform',
    name: 'DataPlatform',
    component: () => import('@/views/DataPlatform')
  },
 
  {
    path: '/h-mon-lg-scrn',
    name: 'HMonLgScrn',
    component: () => import('@/views/HMonLgScrn')
  },
 
  {
    path: '/layout',
    name: 'Layout',
    component: () => import('@/views/Layout'),
    // children:[
    //   {
    //     path: 'collector-management',
    //     name: 'CollectorManagement',
    //     component: () => import('@/views/CollectorManagement'),
    //   },
    //   {
    //     path: 'tree',
    //     name: 'Tree',
    //     component: () => import('@/views/Tree'),
    //   },
    //   {
    //     path: 'eqp-monitor',
    //     name: 'EqpMonitor',
    //     component: () => import('@/views/EqpMonitor'),
    //   }
    // ]
  },
  {
    path:'*',
    component: () => import('@/views/404')
  }
]
export const adminRouters = [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/admin/layout'),
    children: [
      {
        path: 'user-management',
        name: 'UserManagement',
        component: () => import('@/views/admin/UserManagement'),
        meta: { title: '人员管理', icon: 'person' }
      },
      {
        path: 'role-management',
        name: 'RoleManagement',
        component: () => import('@/views/admin/RoleManagement'),
        meta: { title: '角色管理', icon: 'account_box' }
      },
      {
        path: 'menu-management',
        name: 'MenuManagement',
        component: () => import('@/views/admin/MenuManagement'),
        meta: { title: '菜单管理', icon: 'subject' }
      }
    ]
  }
]

const router = new VueRouter({
  scrollBehavior: () => ({y: 0}),
  routes
})

export default router
